<template>
    <div class="myJoin">
        <joinMessage v-for="(jobItem,index) in jobListInfo" :key="index" :jobItem="jobItem"></joinMessage>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
import joinMessage from "../../components/personalCenter/joinMessage";
export default {
  name: "myJoin",
  components: {
    joinMessage
  },
  created() {
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "join");
    this.judgeUserLoginStatus();
  },
  data: function() {
    return {
      jobListInfo: ""
    };
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    },
    hurl: function() {
      return this.$store.state.hurl;
    }
  },
  methods: {
    // 判断用户是否已经登录
    judgeUserLoginStatus: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/User/checkLogin",
        dataType: "json",
        data: {
          cart: this.selectedNumIdArr
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            if (res.data.result) {
              this.getJobListInfo();
            } else {
              Toast("请先登陆");
              // 等1.5秒跳到登录页面
              setTimeout(() => {
                this.$router.push({ path: "/login" });
              }, 1500);
            }
          } else {
            Toast("网络错误,请稍后再试");
          }
        })
        .catch(err => {
          Toast("网络错误,请稍后再试");
          console.log(err);
        });
    },
    // 获取该用户的投递招聘信息
    getJobListInfo: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/user/jobList",
        dataType: "json",
        data: ""
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 1) {
            if (res.data.result) {
              // 有投递信息
              this.jobListInfo = res.data.result.jobs;
            } else {
              // 无投递信息
              Toast(res.data.msg);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";
.myJoin {
  background: @bg;
  padding: 5%;
  width: 90%;
  min-height: 486px;
  .media;
}
</style>
